{
  "name": "admin-portal",
  "version": "1.31.1",
  "description": "Admin Portal for Invintus Media",
  "type": "module",
  "packageManager": "pnpm@10.33.0",
  "alias": {
    "@shared/*": "./src/shared/$1",
    "@server/*": "./src/server/$1",
    "seroval-plugins/web": "./node_modules/seroval-plugins/dist/esm/production/web.mjs"
  },
  "scripts": {
    "postinstall": "prisma generate",
    "prisma:generate": "prisma generate",
    "clean": "rm -rf .parcel-cache dist",
    "clean:logs": "find logs -type f -name '*.log' -exec truncate -s 0 {} +",
    "dev:server": "pnpm run clean:logs && tsx watch src/server/index.ts",
    "dev:client": "parcel src/client/index.html --port 5173",
    "dev": "concurrently \"pnpm:dev:server\" \"pnpm:dev:client\"",
    "build:server": "pnpm run prisma:generate && tsc --project tsconfig.server.json && tsc-alias -p tsconfig.server.json --resolve-full-paths",
    "build:client": "parcel build src/client/index.html --dist-dir dist/client --public-url / --no-scope-hoist",
    "build": "pnpm run build:server && pnpm run build:client",
    "start": "tsx src/server/index.ts",
    "test": "pnpm run test:server",
    "test:server": "node --import tsx --import ./src/server/__tests__/setup.ts --experimental-test-module-mocks --test src/server/__tests__/**/*.test.ts",
    "docker:setup": "bash docker/generate-certs.sh",
    "db:select": "node scripts/select-db.mjs",
    "docker:dev": "pnpm run db:select && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development up --build",
    "docker:dev:down": "docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development down",
    "docker:dev:restart": "docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development down && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development up -d",
    "docker:dev:rebuild": "pnpm run db:select && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development down -v && pnpm run clean && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development build --no-cache && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development up",
    "docker:prod": "docker-compose -f docker-compose.yml -f docker-compose.prod.yml --env-file .env.production up --build",
    "docker:prod:down": "docker-compose -f docker-compose.yml -f docker-compose.prod.yml --env-file .env.production down",
    "docker:prod:detach": "docker-compose -f docker-compose.yml -f docker-compose.prod.yml --env-file .env.production up --build -d",
    "docker:clean:modules": "docker volume rm admin-portal_node_modules",
    "docker:exec": "docker exec -it admin-portal sh"
  },
  "dependencies": {
    "@auth0/auth0-fastify-api": "^1.0.0",
    "@auth0/auth0-react": "^2.8.0",
    "@aws-sdk/client-cloudwatch": "^3.949.0",
    "@aws-sdk/client-ec2": "^3.948.0",
    "@aws-sdk/client-rds": "^3.948.0",
    "@date-fns/tz": "^1.4.1",
    "@fastify/cors": "^10.0.1",
    "@fastify/helmet": "^13.0.2",
    "@fastify/static": "^8.3.0",
    "@prisma/adapter-mariadb": "^7.0.0",
    "@prisma/client": "^7.0.0",
    "@radix-ui/react-checkbox": "^1.3.3",
    "@radix-ui/react-collapsible": "^1.1.12",
    "@radix-ui/react-dialog": "^1.1.15",
    "@radix-ui/react-dropdown-menu": "^2.1.16",
    "@radix-ui/react-label": "^2.1.8",
    "@radix-ui/react-popover": "^1.1.15",
    "@radix-ui/react-progress": "^1.1.8",
    "@radix-ui/react-select": "^2.2.6",
    "@radix-ui/react-separator": "^1.1.8",
    "@radix-ui/react-slot": "^1.2.4",
    "@radix-ui/react-switch": "^1.2.6",
    "@radix-ui/react-tabs": "^1.1.13",
    "@radix-ui/react-toggle": "^1.1.10",
    "@radix-ui/react-tooltip": "^1.2.8",
    "@redux-devtools/extension": "^3.3.0",
    "@tanstack/react-router": "^1.134.12",
    "@tanstack/react-table": "^8.21.3",
    "better-sqlite3": "^12.5.0",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cmdk": "^1.1.1",
    "date-fns": "^4.1.0",
    "dotenv": "^17.2.3",
    "fastify": "^5.1.0",
    "lucide-react": "^0.554.0",
    "markdown-to-jsx": "^9.1.1",
    "next-themes": "^0.4.6",
    "pino": "^10.1.0",
    "pino-pretty": "^13.1.2",
    "react": "^19.2.0",
    "react-day-picker": "^9.11.2",
    "react-dom": "^19.2.0",
    "recharts": "2.15.4",
    "rotating-file-stream": "^3.2.7",
    "scaledrone-node": "^1.5.0",
    "sonner": "^2.0.7",
    "tailwind-merge": "^3.4.0",
    "tsx": "^4.19.2",
    "yazl": "^3.3.1",
    "zod": "^4.3.4",
    "zustand": "^5.0.8"
  },
  "pnpm": {
    "onlyBuiltDependencies": [
      "better-sqlite3"
    ]
  },
  "devDependencies": {
    "@inquirer/prompts": "^8.2.0",
    "@parcel/config-default": "^2.16.1",
    "@parcel/transformer-inline-string": "^2.16.1",
    "@tailwindcss/typography": "^0.5.19",
    "@tanstack/react-router-devtools": "^1.134.12",
    "@types/better-sqlite3": "^7.6.13",
    "@types/node": "^22.9.3",
    "@types/react": "^19.2.2",
    "@types/react-dom": "^19.2.2",
    "@types/yazl": "^3.3.1",
    "autoprefixer": "^10.4.22",
    "concurrently": "^9.2.1",
    "parcel": "^2.16.0",
    "postcss": "^8.5.6",
    "prisma": "^7.0.0",
    "seroval-plugins": "^1.4.0",
    "tailwindcss": "^3.4.18",
    "tsc-alias": "^1.8.16",
    "typescript": "^5.7.2"
  }
}
